import { Link } from "react-router-dom";

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-[#C9A227]">{children}</p>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-display text-3xl sm:text-5xl font-extrabold tracking-tight text-[#f5f2ea] ${className}`}>
    {children}
  </h2>
);

export const Body = ({ children }) => (
  <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#8e8a80]">{children}</p>
);

export const Section = ({ id, children, className = "" }) => (
  <section id={id} className={`border-t border-[#1f1e1a] px-6 py-24 sm:py-32 ${className}`}>
    <div className="mx-auto max-w-6xl">{children}</div>
  </section>
);

export const CtaLink = ({ to, children, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="mt-8 inline-block border border-[#3a3524] px-6 py-3 font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9A227] transition-colors hover:border-[#C9A227]"
  >
    {children}
  </Link>
);

export const StatusChip = ({ status }) => (
  <span className="inline-block border border-[#26241d] px-2.5 py-1 font-mono text-[8px] tracking-[0.25em] text-[#8e8a80]">
    {status}
  </span>
);
